import { useSelector } from 'react-redux'

import { EmptyMail } from '@/icons'

import { preview } from '@/components/form/preview'
import { GoToSettingsButton } from './GoToSettingsButton'

import { selectUserConfiguration } from '@/features/domain/user'

import { useTexts } from './useTexts'

export function NoNotifications() {
  const { rmAdmin } = useSelector(selectUserConfiguration)
  const texts = useTexts()

  return (
    <preview.Section alignItems="center" spacing={2}>
      <EmptyMail size={48} />
      <preview.SectionTitle>{texts.title}</preview.SectionTitle>
      <preview.Description align="center">{texts.description(rmAdmin)}</preview.Description>
      {rmAdmin && <GoToSettingsButton />}
    </preview.Section>
  )
}
